import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import React from 'react';
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlass';

import { useIntl } from 'react-intl';
import InputWithIcon from '../../../components/InputWithIcon';
import { bg200 } from '@osmosis/tailwind-ui/styles';

type Props = {
  searchValue: string;
  handleSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

/**
 * PlaylistSearchField.
 */
const PlaylistSearchField = (props: Props) => {
  const { searchValue, handleSearch } = props;

  const intl = useIntl();

  return (
    <Box className={`flex w-[100%]`}>
      <InputWithIcon
        data-testid="playlist-groups-search-input"
        value={searchValue}
        onChange={handleSearch}
        placeholder={intl.formatMessage({
          id: 'playlist-groups.search',
          defaultMessage: 'Search for playlist name',
        })}
        icon={<Icon icon={faMagnifyingGlass} />}
        className={`h-[30px] text-[14px] bg-bg-0 w-full rounded-[15px] pr-2 ${bg200}`}
      />
    </Box>
  );
};

export default PlaylistSearchField;
